"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    },
    theme: function theme() {
      return this.$store.getters.themeConf;
    }
  },
  methods: {
    customTableColumnWidth: function customTableColumnWidth(size) {
      var customSize = ["sm", "md", "lg"];
      var customWidthEn = [100, 120, 150];

      if (this.locale === "en") {
        var colSize = customSize.indexOf(size);
        var width = customWidthEn[colSize];
        return width;
      }

      return "";
    }
  }
};
exports.default = _default;